module.exports = __webpack_public_path__ + "static/media/body-background.fc05b441.jpg";